import styled from 'styled-components';
import { MessageMedium, EmbeddedMessage, WhatsApp } from 'constants/messageMediums';
import { TemplatePreviewCardEmptyState } from 'ui/illustrations';
import { PlaceholderState } from 'ui/indexPages/PlaceholderState';
import { colors, spacing } from 'ui/theme';

const StyledPlaceholderState = styled(PlaceholderState)`
  background-color: ${colors.interactive10};
  min-height: auto;
  padding: ${spacing.plusHalf} 0;
`;

const MESSAGE_MEDIUM_LABELS = {
  [MessageMedium.SMS]: 'SMS',
  [MessageMedium.Push]: 'push',
  [MessageMedium.WebPush]: 'web push',
  [MessageMedium.InApp]: 'in-app',
  [MessageMedium.Email]: 'email',
  [EmbeddedMessage]: 'embedded',
  [WhatsApp]: 'WhatsApp',
} as const;

export const EmptyTemplatePreview = ({ messageMedium }: { messageMedium: string }) => {
  return (
    <StyledPlaceholderState
      title="Oops, no preview is available"
      Illustration={TemplatePreviewCardEmptyState}
    >
      <p>This {MESSAGE_MEDIUM_LABELS[messageMedium] || messageMedium} campaign is empty.</p>
    </StyledPlaceholderState>
  );
};
